const medicineBazarBt = {
	search: {
		placeholders: [
			'སྨན་མིང་ ནང་འཇུག...',
			'ཇེ་ནེ་རིཀ་མིང་ ནང་འཇུག...',
			'ཚོང་ལས་མིང་ ནང་འཇུག...',
			'བརནཌ་མིང་ ནང་འཇུག...',
			'ཚོང་ཁང་མིང་ ནང་འཇུག...'
		]
	},
	sidebar: {
		categoriesTitle: 'རིགས་',
		storesTitle: 'ཚོང་ཁང་'
	},
	upload: {
		title: 'འཆང་འབྲི་སྣོན།',
		subtitle: 'འཆང་འབྲི་སྣོན་ནས་སྨན་འཇོག་སྤྲོད་ལས་སླ་བོར་འབད།',
		uploadedPrefix: '✓ ཡིག་ཆ་སྣོན་ཡོད: ',
		chooseFile: 'ཡིག་ཆ་གདམ།',
		replaceFile: 'ཡིག་ཆ་གསརཔ་སྣོན།'
	},
	store: {
		serviceAreaLabel: 'ཞབས་ཞུ་མངའ་ཁོངས་',
		nationwide: 'རྒྱལ་ཡོངས་',
		medicineCountLabel: 'སྨན་',
		close: 'ཁ་བསྡམས།',
		productsOfSuffix: 'གི་སྨན་',
		descriptionPrefix: 'འོག་ལུ',
		descriptionSuffix: 'ཕར་མ་སི་ཡི་སྨན་ཐོབ་ཚུགས་པ་ཚང་མ་འཆར་ཡོད། རིགས་གཞན་གྱིས་ཚགས་ནི་ཆོག་'
	},
	card: {
		addToCart: 'ཀརཊ་ནང་བཙུགས།'
	},
	empty: {
		title: 'སྨན་མ་ཐོབ་',
		subtitle: 'རིགས་གཞན་ཡང་ན་ཕར་མ་སི་གཞན་གདམ།'
	},
	prescriptionFlow: {
		successTitle: 'འཆང་འབྲི་སྣོན་པ་མཐར་འཁྱོལ།',
		instruction: 'སྨན་འཇོག་སྤྲོད་ཀྱི་དོན་ལུ འོག་གི་གནས་ཚུལ་ཁ་གསལ་བཀོད།',
		step1: {
			title: 'ཕར་མ་སི་གདམ།',
			subtitle: 'ཕར་མ་སི་ག་གདམ་ནི་ཨིན།',
			next: 'ཤུལ་མམ'
		},
		step2: {
			title: 'གླུ་སྒྲུབ་དུས་ཡུན་གདམ།',
			subtitle: 'ཉིན་གང་ལུ་སྨན་དགོས།',
			fullCourse: 'ཆ་ཚང་གླུ་སྒྲུབ་',
			fiveDays: '༥ ཉིན་གྱི་དོན་ལུ',
			tenDays: '༡༠ ཉིན་གྱི་དོན་ལུ',
			customDays: 'ཉིན་གྱི་གདམ་ཁ',
			customDaysLabel: 'ཉིན་ག་དགོས།',
			customDaysPlaceholder: 'དཔེར་ན: ༡༥',
			back: 'རྒྱབ་',
			next: 'ཤུལ་མམ'
		},
		step3: {
			title: 'གནང་བ་ངེས་ཐག་བཟོ།',
			summaryTitle: 'ཁྱེད་ཀྱི་གནང་བ་གནས་བསྡུས་:',
			pharmacyLabel: 'ཕར་མ་སི་',
			durationLabel: 'དུས་ཡུན་',
			prescriptionLabel: 'འཆང་འབྲི་',
			back: 'རྒྱབ་',
			confirm: 'ངེས་ཐག་བཟོ།'
		},
		snackbar: {
			successTitle: '🎉 གནང་བ་མཐར་འཁྱོལ་སྤྲོད་ཡོད།',
			message: 'ཁྱེད་ཀྱིས་གདམ་ཁ་བརྐྱབས་པའི་ཕར་མ་སིས་མགྱོགས་པར་འབྲེལ་བ་འབད་འོང་།'
		}
	}
};

export default medicineBazarBt;


